import { gql } from "@apollo/client";

export const listTiers = gql`
  query ListTiers {
    listTiers {
      totalCount
      self
      first
      prev
      next
      last
      items {
        id
        name
        programId
        entryThresholdMinor
        multiplier
        benefits
        requirements
        tierRevision
        createdAt
        updatedAt
        createdBy
        updatedBy
        deletedAt
        deletedBy
      }
    }
  }
`;
